<template>
    <BaseChart :series="series"></BaseChart>
</template>
<script>
import BaseChart from '@/views/Guide/charts/baseChart'

export default {
  name: 'GenderAgeChart',
  props: ['series'],
  components: {
    BaseChart
  },
  computed: {
    options () {
      return {
      }
    }
  }
}
</script>
<style scoped>
</style>
